import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, IconButton, Modal } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './index.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moStore, { toggleModalQueryModal } from '@store/index';
import moUser from '@store/user';
import moSkin from '@store/skin';

interface IProps {}
interface IState {}

const DModal = styled(Modal)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 6666666,
}));

const DIconButton = styled(IconButton)(() => ({}));

const DButton = styled(Button)(() => ({
  width: '180px',
  height: '36px',
  borderRadius: '18px',
  color: Color.fff,
}));

const MarketQueryModal = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isMarketQueryModal } = moStore;
  const { saleInfo, userInfo } = moUser;
  const { partner, counselor } = moSkin;

  useEffect(() => {
    return () => {};
  }, []);

  const onContact = () => {
    const btn = document.getElementById('nb_invite_ok');
    if (btn) { btn.click(); }
  };

  return (
    <DModal open={isMarketQueryModal}>
      <section className="market-query-modal_111">
        <p className="line-111">
          <b>提示</b>
          <DIconButton onClick={() => toggleModalQueryModal(false)}>
            <CloseIcon20 color={Color.c999} />
          </DIconButton>
        </p>
        <p className="line-113">
          <strong>您的薪酬报告免费查询仅剩：{userInfo?.remain_market_chance}次，立刻点击下方获取更多免费查询机会！</strong>
          {partner === 'smartsalary' ? (
            <span>顾问专属电话：{saleInfo?.phone}</span>
          ) : (
            <span>联系我们: {counselor?.phoneNum}</span>
          )}
        </p>
        {partner === 'smartsalary' ? (
          <DButton variant="contained" color="secondary" onClick={onContact}>直接联系顾问</DButton>
        ) : null}
      </section>
    </DModal>
  );
};

export default observer(MarketQueryModal);
